(ns shared.core.time
  (:require [cljs-time.coerce :as coerce]
            [cljs-time.format :as format]
            [cljs-time.local :as local]
            [cljs-time.core :as time]
            [shared.core.util :as util]
            [clojure.string :as s]))

;; All in ms
(def one-second 1000)
(def one-minute (* one-second 60))
(def one-hour (* one-minute 60))
(def one-day (* one-hour 24))
(def from-date coerce/from-date)
(def from-string coerce/from-string)
(def now-in-ms (comp coerce/to-long time/now))

(defn reformat-date-str [date-string to-format]
  (try
    (format/unparse (format/formatter to-format) (coerce/from-string date-string))
    (catch :default e "")))

(defn try-from-string [date-string]
  (try
    (coerce/from-string date-string)
    (catch :default _ nil)))

(defn ghetto-parse-local-string
  "This is some seriously WTF shit...might be a specific version of Chrome issue, BUT it's not detecting spaces or
  something bizarre with the date string coming in, so this works for now"
  [date-string]
  (when-let [date-parts (some-> date-string (s/replace "/" "-") (s/split ", "))]
    (let [last-parts (s/split (last date-parts) " ")
          time-parts (s/split (first last-parts) ":")
          hr (first time-parts)
          min (second time-parts)
          sec (last time-parts)
          sec-has-both? (> (count sec) 2)
          am-pm (if sec-has-both?
                  (cond
                    (s/includes? sec "AM") "AM"
                    (s/includes? sec "PM") "PM"
                    :else nil)
                  (last last-parts))
          sec (if sec-has-both? (subs sec 0 2) sec)
          ghetto-date-string (str (first date-parts) ", " (str hr ":" min ":" sec " " am-pm))]
      (->> ghetto-date-string (format/parse (format/formatter "M-d-yyyy, h:mm:ss A"))))))

(defn parse-locale-string [date-string]
  (try
    (some->> date-string (format/parse (format/formatter "M/d/yyyy, h:mm:ss A")))
    (catch :default _
      (ghetto-parse-local-string date-string))))

(defn tz->locale-string [tz]
  (try
    (some-> (new js/Date) (.toLocaleString "en-US" (clj->js {"timeZone" tz})) (str))
    (catch :default _ nil)))

(defn utc-locale-string []
  (tz->locale-string "UTC"))

(defn tz-offset-seconds [timezone]
  (/ (- (.getTime (new js/Date (utc-locale-string)))
        (.getTime (new js/Date (tz->locale-string timezone))))
     1000))

(defn tz-local-offset-seconds [timezone]
  (js/Math.round
    (/ (- (.getTime (new js/Date (tz->locale-string timezone)))
          (.getTime (new js/Date)))
       1000)))

(defn tz-parsed-date [in-time timezone]
  (some-> (format/parse in-time)
          (time/minus (time/seconds (tz-offset-seconds timezone)))))

(defn tz-dt->utc-date-time-string [in-time timezone]
  (when in-time
    (some->> (time/plus in-time (time/seconds (tz-offset-seconds timezone)))
             (format/unparse (format/formatter "yyyy-MM-dd'T'HH:mm:ss.SSSZZ")))))

(defn utc-datetime->local [in-datetime]
  (time/minus in-datetime (time/seconds (tz-local-offset-seconds "UTC"))))

(defn utc->local [in-time]
  (utc-datetime->local (format/parse in-time)))

(defn tz->date-string [{:keys [tz format]}]
  (try
    (let [locale-string (tz->locale-string tz)]
      (if format
        (format/unparse (format/formatter format) (parse-locale-string locale-string))
        locale-string))
    (catch :default e
      nil)))

(defn relative-time-label
  "A compact 'how long ago' label for an ISO-8601 timestamp string — 'Just now', '5m
   ago', '3h ago', 'Yesterday', then the date. Parsed with `js/Date` rather than the
   cljs-time formatters: those only match millisecond precision, and a Postgres
   timestamp arrives with microseconds. Empty string when there is nothing to parse."
  [date-string]
  (let [date (when-not (s/blank? date-string) (js/Date. date-string))
        ms (some-> date (.getTime))]
    (if (or (nil? ms) (js/isNaN ms))
      ""
      (let [minutes (quot (- (now-in-ms) ms) one-minute)
            hours (quot minutes 60)
            days (quot hours 24)]
        (cond
          (< minutes 1) "Just now"
          (< minutes 60) (str minutes "m ago")
          (< hours 24) (str hours "h ago")
          (= days 1) "Yesterday"
          (< days 7) (str days "d ago")
          :else (.toLocaleDateString date "en-US" #js {:month "short"
                                                       :day "numeric"
                                                       :year "numeric"}))))))

(defn str->formatted-local-time [t to-format]
  (try
    (format/unparse (format/formatter to-format) (local/to-local-date-time t))
    (catch :default e "")))

(defn seconds-to-next-minute []
  (some->> (format/unparse (format/formatter "s") (time/now))
           (util/parse-int)
           (- 60)))

(defn minutes-to-next-hour []
  (some->> (format/unparse (format/formatter "m") (time/now))
           (util/parse-int)
           (- 60)))

(defn tz-time-now [tz]
  (some-> tz (tz->locale-string) (parse-locale-string)))

(defn as-format [in-time in-format]
  (some->> in-time (format/unparse (format/formatter in-format))))

(defn as-y-m-d [in-time]
  (as-format in-time "yyyy-MM-dd"))

(defn as-day-of-week [in-time]
  (as-format in-time "EEEE"))

(defn as-hours [in-time]
  (as-format in-time "H"))

(defn as-minutes [in-time]
  (as-format in-time "m"))

(defn tz-now-as-y-m-d [tz]
  (some-> tz (tz-time-now) (as-y-m-d)))

(defn tz-now-as-day-of-week [tz]
  (some-> tz (tz-time-now) (as-day-of-week)))

(defn tz-now-as-hours [tz]
  (some-> tz (tz-time-now) (as-hours)))

(defn tz-now-as-minutes [tz]
  (some-> tz (tz-time-now) (as-minutes)))

(defn between-start-and-end-date-times? [timezone time-start-str time-end-str]
  (or (not timezone)
      (and (s/blank? time-start-str) (s/blank? time-end-str))
      (let [t-now (tz-time-now timezone)
            t-start (some-> time-start-str (coerce/from-string))
            t-end (some-> time-end-str (coerce/from-string))]
        (and (or (not t-start) (time/after? t-now t-start))
             (or (not t-end) (time/before? t-now t-end))))))

(defn minutes->seconds [m]
  (* m 60))

(defn hours->minutes [h]
  (* h 60))

(defn seconds->hours [s]
  (-> s (/ 3600) (js/Math.round)))

(defn seconds->format [in-s]
  (let [s-tmp (js/Math.round (mod in-s 60))
        s (if (= s-tmp 60) 0 s-tmp)
        m-tmp (+ (mod (quot in-s 60) 60) (if (= s-tmp 60) 1 0))
        m (if (= m-tmp 60) 0 m-tmp)
        h (+ (quot in-s 3600) (if (= m-tmp 60) 1 0))]
    (str (when (> h 0) (str h ":"))
         (if (> h 0)
           (str (when (< m 10) "0") m)
           m)
         ":"
         (when (< s 10) "0")
         s)))

(defn seconds->h-m-s [in-s]
  (let [s-tmp (js/Math.round (mod in-s 60))
        s (if (= s-tmp 60) 0 s-tmp)
        m-tmp (+ (mod (quot in-s 60) 60) (if (= s-tmp 60) 1 0))
        m (if (= m-tmp 60) 0 m-tmp)
        h (+ (quot in-s 3600) (if (= m-tmp 60) 1 0))]
    (->> [(when (> h 0) (str h "h"))
          (when (> m 0) (str m "m"))
          (when (> s 0) (str s "s"))]
         (filterv identity)
         (s/join " "))))

(defn strip-seconds [hms]
  (if (re-matches #"\d{2}:\d{2}:\d{2}" hms)
    (clojure.string/replace hms #":00$" "")
    hms))
